import * as yup from "yup";
import FormikAutocomplete from "../../commons/formik/formikAutocomplete";
import FormikForm from "../../commons/formik/formikForm";
import CircularLoading from "../../commons/loadingData/circularLoading";
import { StyledServiceMonitorSearchForm } from "../../styled/serviceMonitor";

const validationSchema = yup.object().shape({
});

const initialValues = {
  art: "",
};


const ServiceMonitorSearchForm = ({
  loading,
  arts,
  handleSubmitSearch,
  model,
}) => {

  return (
    <div>
      <StyledServiceMonitorSearchForm.StyledPaper>
        {!loading ? (
          <FormikForm
            initialValues={model ?? initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmitSearch}>
            {({ values }) => (
              <StyledServiceMonitorSearchForm.StyledForm>

                <StyledServiceMonitorSearchForm.StyledInput>
                  <FormikAutocomplete
                    options={arts || []}
                    name="art"
                    label="Art"
                    variant="standard"
                  />
                </StyledServiceMonitorSearchForm.StyledInput>

                <StyledServiceMonitorSearchForm.ButtonContainer>
                  <StyledServiceMonitorSearchForm.StyledButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={loading}>
                    Buscar
                  </StyledServiceMonitorSearchForm.StyledButton>
                </StyledServiceMonitorSearchForm.ButtonContainer>
              </StyledServiceMonitorSearchForm.StyledForm>
            )}
          </FormikForm>
        ) : (
          <CircularLoading />
        )}
      </StyledServiceMonitorSearchForm.StyledPaper>
    </div>
  );
};

export default ServiceMonitorSearchForm;
